 <app-form-input 
[parentForm]="parentForm" 
[value]="oui.grpCoordonnateur" 
 
[label]="step2.getgrpcoordonnateur"
[type]="'text'"
[disabled]="disabled"
[rule]="'minSize_1|maxSize_300|required'"
[errorMessage]="{'required' : 'ctr_1070'}"
[name]="getUid()+'_SepAtt_grpCoordonnateur'">
</app-form-input>
